import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAddPayment,
        popUpMessageChange, 
        closedCardsGroupsChange,
        editCards, 
        editFeaturesGroup, 
        editFigures } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';

import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';

class PaidButton extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            percentageValue: 50,
        }
    }

    handleOnClick = async () => {
        const message =  _('Agregando Pago')+'...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            'paid_percentage': this.state.percentageValue,
            'cards_group_ids': this.props.addPayment.cardsGroupIds,
        }
        let cardsGroupIds = this.props.addPayment.cardsGroupIds
        this.handleClose()
        let response = await postData('/web-api/add-paid-percentage', urlPost)
        this.handleResponse(response, cardsGroupIds)
    }

    handleClose = () => {
        this.props.setAddPayment({})
        this.setState({ percentageValue: 50 })
    }

    handleResponse = (response, cardsGroupIds) => {
        const success = response.status === 'success';
        const message = success ? '¡' + _('Porcentaje de pago agregado exitosamente') + '!' : _('Ocurrió un error, no se pudo agregar el porcentaje de pago');
        showMessage(this.props, message);
        if (success) {
            reloadCardsGroupsFeatures(this.props, cardsGroupIds);
        }
    }

    handlePaidChange = (event) => {
        this.setState({ percentageValue: event.target.value })
    }


    render(){   
        let render = this.props.addPayment.show
        return (
            <div>
                { render ? (
                    <div>
                        <div className='sensitive-background' onClick={this.handleClose}></div>
                        <div className="add-progress-card-layout card-color">
                            <h3 className='text-center'>{_("Ingrese un porcentaje de Pago")}</h3>
                            <h4 className='text-center progress-number'>{ this.state.percentageValue + '%'}</h4>
                            <div className='my-4'>
                                <input 
                                type="range" 
                                className="timeslider timeslider-element"
                                min={0}
                                value={this.state.percentageValue}
                                max={100}
                                onChange={this.handlePaidChange}/>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" onClick={this.handleOnClick} className='success-button'>
                                    <SendIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Agregar Pago')}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        addPayment : state.addPayment,
        projectData : state.projectData,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        setAddPayment : setAddPayment,
        popUpMessageChange : popUpMessageChange,
        closedCardsGroupsChange : closedCardsGroupsChange,
        editFeaturesGroup : editFeaturesGroup,
        editCards : editCards,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(PaidButton)